import React from 'react';
import { Link } from 'react-router-dom';

import NavbarTools, { useNavbarTheme } from '../NavbarTools';

function Navbar({ title, to }) {
  const navbarTheme = useNavbarTheme();

  return (
    <nav className={`main-header navbar navbar-expand ${navbarTheme}`}>
      <ul className="navbar-nav">
        <li className="nav-item">
          <a className="nav-link" data-widget="pushmenu" href="/" role="button">
            <i className="fas fa-bars" />
          </a>
        </li>
        {title && (
          <li className="nav-item d-none d-sm-inline-block">
            <Link to={to} className="nav-link">
              <strong>{title}</strong>
            </Link>
          </li>
        )}
      </ul>

      <ul className="navbar-nav ml-auto">
        <NavbarTools />
      </ul>
    </nav>
  );
}

export default Navbar;
